import { render, staticRenderFns } from "./AllocationTabs.vue?vue&type=template&id=13af5888"
import script from "./AllocationTabs.vue?vue&type=script&lang=js"
export * from "./AllocationTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports